import { type VariantProps, cva } from 'class-variance-authority';
import { cn } from '../lib/utils';

const spinnerVariants = cva(
  'w-16 h-16 border-4 border-t-4 border-gray-200 border-t-primary rounded-full animate-spin',
  {
    variants: {
      variant: {
        default: 'border-gray-200 border-t-primary',
      },
      size: {
        default: 'size-4 border-2 border-t-2',
        lg: 'size-10 border-4 border-t-4',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

interface LoadingSpinnerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof spinnerVariants> {
  className?: string;
}

const LoadingSpinner = ({ className, variant, size, ...props }: LoadingSpinnerProps) => {
  return <div className={cn(spinnerVariants({ variant, size, className }))} {...props} />;
};

LoadingSpinner.displayName = 'LoadingSpinner';

function LoadingDots({ className = '' }: { className?: string }) {
  return (
    <div className={cn('flex flex-row h-0.5 items-center text-white/60', className)}>
      <span className="font-inter font-medium animate-bounce">.</span>
      <span className="font-inter font-medium animate-bounce delay-100">.</span>
      <span className="font-inter font-medium animate-bounce delay-200">.</span>
    </div>
  );
}

export { LoadingSpinner, LoadingDots };
